import { assign } from "nodemailer/lib/shared";
import {
  COURSES_LOADING,
  GET_ALL_ASSIGNMENT_DOCUMENTS,
  GET_ASSIGNMENT_DOCUMENTS_BY_COURSE_AND_USER,
  GET_INDIVIDUAL_ASSIGNMENT_DOCUMENT,
} from "../actions/types";

const initialState = {
  loading: false,
  assignmentDocumentList: [],
  individualAssignmentDocument: [],
  assignmentDocumentsByCourseAndUser: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case COURSES_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_ASSIGNMENT_DOCUMENTS:
      return {
        ...state,
        assignmentDocumentList: action.payload,
        loading: false,
      };
    case GET_INDIVIDUAL_ASSIGNMENT_DOCUMENT:
      return {
        ...state,
        individualAssignmentDocument: action.payload,
        loading: false,
      };
    case GET_ASSIGNMENT_DOCUMENTS_BY_COURSE_AND_USER:
      return {
        ...state,
        assignmentDocumentsByCourseAndUser: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
